import React from "react";
import styles from "./ClinicalSummaries.module.css";
import BreadCrum from "../../BreadCrum/BreadCrum";
import { useSearchParams } from "react-router-dom";
import categoryContent from "../../../json/categoryContent.json";

const ClinicalSummaries = () => {
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");

  const formattedCategory = category
    ? category.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "";

  const firstItem = categoryContent[category]?.items?.[0];

  return (
    <>
      <BreadCrum />
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1 className={styles.title}>{formattedCategory}</h1>

          <div className={styles.card}>
            <img alt="Healio Health" src="/Images/clinical_summaries.webp" loading="lazy" decoding="async" />
          </div>
          <div className={styles.content}>
            <h3 className={styles.heading}>
              {firstItem?.title || "Advancing science through evidence"}
            </h3>

            {firstItem?.date && (
              <p className={styles.date}>{firstItem.date}</p>
            )}

            <p className={styles.description}>
              {firstItem?.description ||
                "Clinical Summaries provide a concise view of completed clinical studies — highlighting objectives, key findings, and outcomes. These summaries are designed to make scientific evidence easier to understand while prese..."}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClinicalSummaries;
